export const graficoBarrasStyles = {}
